import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Settings, Database, Map, PlayCircle, Activity, ChevronRight } from 'lucide-react';

const SuccessWarePage = () => {
  const sections = [
    {
      title: 'Credentials & Environment',
      description: 'API authentication, access tokens, and environment selection',
      icon: Settings,
      href: '/integrations/successware/credentials',
      status: 'configured'
    },
    {
      title: 'Operation Catalog',
      description: 'Browse all API operations, input types, and sample queries',
      icon: Database,
      href: '/integrations/successware/catalog',
      status: 'configured'
    },
    {
      title: 'Field Catalog',
      description: 'Document and categorize all 849 SuccessWare API fields',
      icon: Database,
      href: '/integrations/successware/fields',
      status: 'configured'
    },
    {
      title: 'Field Mappings',
      description: 'Map widget fields to SuccessWare inputs with transformations',
      icon: Map,
      href: '/integrations/successware/mappings',
      status: 'pending'
    },
    {
      title: 'API Runner',
      description: 'Test API operations with live or mock data',
      icon: PlayCircle,
      href: '/integrations/successware/runner',
      status: 'pending'
    },
    {
      title: 'Activity Monitor',
      description: 'Live view of customer and data imports in real-time',
      icon: Activity,
      href: '/integrations/successware/activity',
      status: 'active'
    },
    {
      title: 'Logs & Health',
      description: 'Monitor API calls, errors, and performance metrics',
      icon: Activity,
      href: '/integrations/successware/logs',
      status: 'pending'
    }
  ];

  const statusColors: Record<string, string> = {
    configured: 'bg-green-500/20 text-green-400 border-green-500/30',
    ready: 'bg-blue-500/20 text-blue-400 border-blue-500/30',
    pending: 'bg-yellow-500/20 text-yellow-400 border-yellow-500/30',
    active: 'bg-purple-500/20 text-purple-400 border-purple-500/30'
  };

  return (
    <div className="p-6">
      <div className="mb-8">
        <div className="flex items-center gap-2 text-slate-400 text-sm mb-4">
          <Link to="/integrations" className="hover:text-white">Integrations</Link>
          <ChevronRight className="w-4 h-4" />
          <span className="text-white">SuccessWare</span>
        </div>
        <h1 className="text-3xl font-bold text-white mb-2">SuccessWare Integration</h1>
        <p className="text-slate-400">
          Centralized API management, field mappings, and monitoring
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-6">
        {sections.map((section) => {
          const Icon = section.icon;
          return (
            <Link
              key={section.href}
              to={section.href}
              className="block p-6 bg-slate-900 border border-slate-800 rounded-lg hover:border-slate-700 transition-all group"
            >
              <div className="flex items-start justify-between mb-4">
                <div className="inline-flex p-3 rounded-lg bg-blue-500/10 text-blue-400 border border-blue-500/20">
                  <Icon className="w-6 h-6" />
                </div>
                <span className={`px-2 py-1 rounded text-xs font-medium border ${statusColors[section.status]}`}>
                  {section.status}
                </span>
              </div>
              <h3 className="text-lg font-semibold text-white mb-2 group-hover:text-blue-400 transition-colors">
                {section.title}
              </h3>
              <p className="text-slate-400 text-sm">
                {section.description}
              </p>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default SuccessWarePage;
